export default __webpack_public_path__ + "static/media/Icon_Cameo.241bd9fe.svg";